import {
  FontFamily,
  FontSize,
  FontWeight,
} from '../../storyblocks-design-system/components/atoms/Text/Text';

export const FONT_FAMILY_OPTIONS = [
  { label: 'Polysans', value: 'polysans' as FontFamily },
  { label: 'Inter', value: 'inter' as FontFamily },
];

export const FONT_SIZE_OPTIONS: Array<{ label: string; value: FontSize }> = [
  { label: 'Extra Small', value: 'xs' },
  { label: 'Small', value: 'sm' },
  { label: 'Base', value: 'base' },
  { label: 'Large', value: 'lg' },
  { label: 'Extra Large', value: 'xl' },
  { label: '2X Large', value: '2xl' },
  { label: '3X Large', value: '3xl' },
  { label: '4X Large', value: '4xl' },
  { label: '5X Large', value: '5xl' },
];

export const FONT_WEIGHT_OPTIONS: Array<{ label: string; value: FontWeight }> =
  [
    { label: 'Regular', value: 'regular' },
    { label: 'Semibold', value: 'semibold' },
    { label: 'Bold', value: 'bold' },
  ];

export const getFontWeightOptions = (
  fontSize: FontSize,
  fontFamily: FontFamily
) => {
  const largeSizes = ['3xl', '4xl', '5xl'];
  const interBoldSizes = ['xs', 'sm', 'base', 'lg'];

  if (largeSizes.includes(fontSize)) {
    return [{ label: 'Semibold', value: 'semibold' as FontWeight }];
  }

  if (fontFamily === 'inter' && interBoldSizes.includes(fontSize)) {
    return FONT_WEIGHT_OPTIONS;
  }

  return FONT_WEIGHT_OPTIONS.filter((option) => option.value !== 'bold');
};

export const getDefaultFontWeight = (
  fontSize: FontSize,
  fontFamily: FontFamily
): FontWeight => {
  const largeSizes = ['3xl', '4xl', '5xl'];

  if (largeSizes.includes(fontSize)) {
    return 'semibold';
  }

  return 'semibold';
};

export const createFontConfigInputs = () => [
  {
    name: 'fontFamily',
    type: 'string',
    defaultValue: 'polysans',
    enum: FONT_FAMILY_OPTIONS,
    helperText: 'Font family',
    onChange: (options: any) => {
      const size = options.get('fontSize');
      const family = options.get('fontFamily');
      const weight = options.get('fontWeight');

      const largeSizes = ['3xl', '4xl', '5xl'];
      const interBoldSizes = ['xs', 'sm', 'base', 'lg'];

      if (largeSizes.includes(size)) {
        if (weight !== 'semibold') {
          options.set('fontWeight', 'semibold');
        }
      } else if (family === 'inter' && interBoldSizes.includes(size)) {
        // bold allowed
      } else {
        if (weight === 'bold') {
          options.set('fontWeight', 'regular');
        }
      }
    },
  },
  {
    name: 'fontSize',
    type: 'string',
    defaultValue: 'xl',
    enum: FONT_SIZE_OPTIONS.map((option) => option.value),
    helperText: 'Font size for the text',
    onChange: (options: any) => {
      const size = options.get('fontSize');
      const family = options.get('fontFamily');
      const weight = options.get('fontWeight');

      const largeSizes = ['3xl', '4xl', '5xl'];
      const interBoldSizes = ['xs', 'sm', 'base', 'lg'];

      if (largeSizes.includes(size)) {
        if (weight !== 'semibold') {
          options.set('fontWeight', 'semibold');
        }
      } else if (family === 'inter' && interBoldSizes.includes(size)) {
        // valid weights include bold
      } else {
        if (weight === 'bold') {
          options.set('fontWeight', 'regular');
        }
      }
    },
  },
  {
    name: 'fontWeight',
    friendlyName: 'Font weight',
    type: 'string',
    defaultValue: 'semibold',
    enum: [{ label: 'Semibold', value: 'semibold' }],
    showIf: '["3xl","4xl","5xl"].includes(options.get("fontSize"))',
  },
  {
    name: 'fontWeight',
    friendlyName: 'Font weight',
    type: 'string',
    defaultValue: 'semibold',
    enum: [
      { label: 'Regular', value: 'regular' },
      { label: 'Semibold', value: 'semibold' },
    ],
    showIf:
      '!( ["3xl","4xl","5xl"].includes(options.get("fontSize")) ) && !(options.get("fontFamily") === "inter" && ["xs","sm","base","lg"].includes(options.get("fontSize")))',
  },
  {
    name: 'fontWeight',
    friendlyName: 'Font weight',
    type: 'string',
    defaultValue: 'semibold',
    enum: [
      { label: 'Regular', value: 'regular' },
      { label: 'Semibold', value: 'semibold' },
      { label: 'Bold', value: 'bold' },
    ],
    showIf:
      'options.get("fontFamily") === "inter" && ["xs","sm","base","lg"].includes(options.get("fontSize"))',
  },
];
